import React, { useState, useEffect } from 'react';
import { usePlayerContext } from '../../Context';
import { Events, NotificationAction } from '../../../types/player';
import ControlIcon from '../../ui/ControlIcon';

const Action = () => {
  const { sdk } = usePlayerContext();
  const [action, setAction] = useState('');

  const actionsIcon = {
    [NotificationAction.PLAY]: 'play',
    [NotificationAction.PAUSE]: 'circlePause',
  };
  useEffect(() => {
    sdk.on(Events.NOTIFICATION_ACTION, (action: NotificationAction) => {
      const actionIcon = actionsIcon[action];
      if (actionIcon) setAction(actionIcon);
      setTimeout(() => {
        setAction('');
      }, 900);
    });
  }, []);

  const prefix = sdk.getClassNamePrefix();
  if (!action) return null;
  return (
    <div className={`${prefix}-player-notification-action`}>
      <ControlIcon iconName={action} />
    </div>
  );
};

export default Action;
